// Global contact configuration for DELVANTE Visa Platform

const contacts = {
  email: 'info@DELVANTEglobal.com',
  homeContactEmail: 'info@DELVANTEglobal.com',
  calendlyUrl: import.meta.env.VITE_CALENDLY_URL || 'https://calendly.com/delvanteglobal',
  /** Quiz subdomain – quiz-ul din DB rulează aici. Dev: http://localhost:3000. Prod: setează VITE_QUIZ_URL */
  quizUrl: import.meta.env.VITE_QUIZ_URL || 'http://localhost:3000',
  /** Slug-ul quiz-ului implicit din baza de date */
  defaultQuizSlug: import.meta.env.VITE_QUIZ_SLUG || 'default-quiz',
  // Phone
  phone: {
    display: '06 83 81 379', // How phone appears to users
    link: 'tel:+37368381379',  // Actual phone link (remove spaces for tel: link)
    raw: '+37368381379'         // Raw format for backend/APIs
  },


  // Social Media
  social: {
    instagram: {
      url: 'https://www.instagram.com/delvanteglobal/',
      handle: '@delvanteglobal'
    },
    facebook: {
      url: 'https://www.facebook.com/delvanteglobal/',
      handle: '@delvanteglobal'
    },
    // TODO: adaugă linkul X (Twitter) — lasă gol până e disponibil
    x: {
      url: '',
      handle: ''
    },
    tiktok: {
      url: 'https://www.tiktok.com/@delvanteglobal',
      handle: '@delvanteglobal'
    },
    whatsapp: {
      url: 'https://wa.me/37376857038',
      handle: '+373 79 980 190'
    },
    telegram: {
      url: 'https://t.me/+37376857038',
      handle: '@infoDELVANTEglobal.com'
    },
    viber: {
      url: 'viber://chat?number=%2B37376857038',
      handle: '+373 79 980 190'
      }
  },
 
};

export default contacts;
